import { default as React, useMemo } from "react";
import { useSelector } from "react-redux";
import {
  Legend,
  Line,
  LineChart,
  ResponsiveContainer,
  Tooltip,
  XAxis
} from "recharts";
import { formatDate } from "app/DealMachineCore/actions";

export const UserReport = ({ affiliateData }) => {
  const colors = useSelector(state => state.settings.colors);

  const signupData = useMemo(() => {
    if (!affiliateData.report || !affiliateData.report.length) return [];
    return affiliateData.report.map((entry, i) => ({
      date_created: formatDate(entry.date_created),
      signups: entry.signups,
      total_active_subscribers: entry.total_active_subscribers
    }));
  }, [affiliateData]);

  return (
    <ResponsiveContainer>
      <LineChart
        data={signupData}
        margin={{ top: 20, right: 45, left: 20, bottom: 10 }}
      >
        <XAxis
          dataKey="date_created"
          height={80}
          tick={({ x, y, payload }) => (
            <g transform={`translate(${x},${y})`}>
              <text
                x={0}
                y={0}
                dy={16}
                textAnchor="end"
                fill={colors.text_color}
                transform="rotate(-30)"
              >
                {payload.value}
              </text>
            </g>
          )}
        />
        <Tooltip />
        <Line name="Signups" dataKey="signups" stroke={colors.green_color} />
        <Line
          name="Total active subscribers"
          dataKey="total_active_subscribers"
          stroke={colors.active_color}
        />
        <Legend verticalAlign="top" height={36} />
      </LineChart>
    </ResponsiveContainer>
  );
};
